import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tab_view_container" }
const _hoisted_2 = {
  key: 0,
  class: "rate_limit_mask"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "rate_limit_text" }
const _hoisted_5 = {
  key: 1,
  class: "tab_wrapper"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { watch, computed, onActivated, ref, getCurrentInstance, type ComponentInternalInstance } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import APIRequest from '@/api'
import { useThemeColor } from '@/utils/theme'
import { useUsersStore } from '@/stores/users'
import { useSystemStore } from '@/stores/system'
import { TabData } from '@/api/Models/AppTabs'
import qs from 'qs'
import { skipExternalMall, isWeimobMall } from '@/utils/navigation'
// import { isWechat } from '@/utils/weixin'
import { useAuthStore } from '@/stores/login'


const __default__ = {
  name: 'tab'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "26b0985e": (_unref(themeColor))
}))

const { proxy } = getCurrentInstance() as ComponentInternalInstance
const tabsRateLimited = ref(false)
const globalRateLimited = ref(false)
const rateLimitImg = require('@/assets/images/empty/error.png')
const showRateLimitMask = computed(() => {
  const loginPaths = ['/login', '/enterpriseLogin', '/phoneLogin', '/multiAccount']
  const isLoginPage = loginPaths.some((path) => route.path.startsWith(path))
  return !isLoginPage && (tabsRateLimited.value || globalRateLimited.value)
})

const navigateHandle = (item: TabData, navigate: () => void) => {
  if (isWeimobMall(item)) {
    skipExternalMall(item.jumpUrl)
    return ''
  }
  if (item.jumpUrl && item.jumpUrl.indexOf('#') > -1) {
    window.location.href = item.jumpUrl
    // if (isFeishu) {
    //   if (item.jumpUrl) {
    //     window.location.href = item.jumpUrl
    //   } else {
    //     navigate(getLink(item))
    //   }
    // } else {
    //   navigate(getLink(item))
    // }
  } else {
    navigate()
  }
}

const route = useRoute()
const getLink = (item: TabData) => {
  const code = item.defaultCode
  if (code === 'home') {
    return '/'
  }
  if (code === 'course') {
    return `/course?${qs.stringify(route.query)}`
  }
  if (code === 'community') {
    return '/community'
  }
  if (code === 'live') {
    return '/liveStream'
  }
  if (code === 'mine') {
    return '/my'
  }
  if (code === 'welfareMall') {
    return '/shopIndexTab'
  }
  if (code === 'lecturer') {
    return '/lecturerCenterTab'
  }
  if (code === 'task') {
    return '/taskTab'
  }
  if (code === 'study') {
    return '/myStudyTab'
  }
  // 报名
  if (code === 'signUp') {
    return '/applyCenterTab'
  }
  if (code === 'project') {
    return '/myTrainingTab'
  }
  if (code === 'exam') {
    return '/examPractiseTab'
  }
  if (code === 'survey') {
    return '/mySurveyTab'
  }
  // 面授
  if (code === 'offlineTrain') {
    return '/faceTeachingTab'
  }
  if (code === 'team') {
    return '/teamStudyListTab'
  }
  if (code === 'message') {
    return '/newsTab'
  }
  if (code === 'teaching') {
    return '/teachManage/TeachManageListTab'
  }
  // 管理员工作台入口
  if (code === 'workBench') {
    return '/workbenchTab'
  }

  if (!code && item.jumpUrl) {
    if (item.jumpUrl?.indexOf('web') > -1) {
      // window.location.href = item.jumpUrl
      return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
    } else {
      const str = process.env.VUE_APP_ENV === 'prod' ? 'share.sandstalk.com/s' : 'sands-system/s'
      if (item.jumpUrl?.indexOf(str) > -1) {
        // return `/tabCommonView?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabCommonView/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      } else {
        // return `/tabWebview?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      }
    }
  }
  return ''
}

const themeColor = useThemeColor()

const router = useRouter()
const usersStore = useUsersStore()
const authStore = useAuthStore()
const { collegeId, allTabOptions } = storeToRefs(usersStore)

const filterTabOptions = computed(() => {
  return filterByPermissions(
    allTabOptions.value.filter((item: TabData) => {
      // if (isWeimobMall(item) && isWechat) {
      //   return false
      // }
      return true
    })
  )
})
const { setTabOptions, setAllTabOptions } = usersStore

const filterByPermissions = (navigations: TabData[]) => {
  return navigations.filter((item) => {
    if (item.defaultCode === 'team' && authStore?.userAuth?.teamLearningLabel !== 1) {
      return false
    }
    if (item.defaultCode === 'teaching' && authStore?.userAuth?.teachingMgtLabel !== 1) {
      return false
    }
    if (item.defaultCode === 'workBench' && authStore?.userAuth?.workbenchLabel !== 1) {
      return false
    }
    return true
  })
}

const getTabs = async () => {
  const { code, data } = await APIRequest.Home.postAppTabs({
    clientType: 3,
    collegeId: collegeId.value === '-1' ? '' : collegeId.value
  })
  if (code === 429) {
    tabsRateLimited.value = true
    proxy?.$bus.emit('home_rate_limited')
    return
  }
  if (code === 1) {
    tabsRateLimited.value = false
    const navigations = data.navigations || []
    setAllTabOptions(navigations)
    let navigationsList: TabData[] = []
    navigationsList = filterByPermissions(navigations)
    setTabOptions(navigationsList)
    if (route.name !== 'home') {
      return
    }
    navigations.forEach((item) => {
      if (item.isDefaultPage === 1) {
        router.replace(getLink(item))
      }
    })
  } else {
    usersStore.resetState()
  }
}

proxy?.$bus.on('home_rate_limit_retry', () => {
  tabsRateLimited.value = false
  getTabs()
})

const systemStore = useSystemStore()
const { lang } = storeToRefs(systemStore)
onActivated(() => {
  const needGetTabs = sessionStorage.getItem('needGetTabs')
  if (needGetTabs) {
    if (!tabsRateLimited.value) {
      getTabs()
    }
    sessionStorage.removeItem('needGetTabs')
  }
})
watch(
  [collegeId, lang],
  () => {
    if (tabsRateLimited.value) return
    getTabs()
  },
  {
    immediate: true
  }
)

const handleRateLimitRetry = () => {
  tabsRateLimited.value = false
  globalRateLimited.value = false
  proxy?.$bus.emit('home_rate_limit_retry')
  getTabs()
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showRateLimitMask.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "rate_limit_img",
            src: _unref(rateLimitImg)
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('当前使用人数过多,请稍后再试')), 1),
          _createElementVNode("button", {
            class: "rate_limit_btn",
            onClick: handleRateLimitRetry
          }, _toDisplayString(_ctx.$t('重试')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _unref(route).fullPath
          }))
        ], 1024))
      ]),
      _: 1
    }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "placeholer" }, null, -1)),
    (filterTabOptions.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterTabOptions.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: getLink(item),
              custom: "",
              key: index,
              replace: item.defaultCode !== 'live'
            }, {
              default: _withCtx(({ navigate, isExactActive }) => [
                _createElementVNode("li", {
                  class: "tab_item",
                  onClick: ($event: any) => (navigateHandle(item, navigate))
                }, [
                  _withDirectives(_createElementVNode("img", {
                    src: item.choseImgUrl,
                    class: "item_img"
                  }, null, 8, _hoisted_7), [
                    [_vShow, isExactActive]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    src: item.defaultImgUrl,
                    class: "item_img"
                  }, null, 8, _hoisted_8), [
                    [_vShow, !isExactActive]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["item_text", { item_text_active: isExactActive }])
                  }, _toDisplayString(item.name), 3)
                ], 8, _hoisted_6)
              ]),
              _: 2
            }, 1032, ["to", "replace"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})